<template>
	<div id="Paginas">

		<!--//* Editar página  -->
		<v-dialog v-model="editPageModal.enabled" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Editar nome da página</span>
				</v-card-title>
				<v-card-text>
					<v-layout wrap>
						<v-flex xs12>
							<v-text-field v-model="nomePagina" label="Novo nome" required></v-text-field>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" flat @click="editPageModal.enabled = false">Cancelar</v-btn>
					<v-btn color="green darken-1" dark @click="saveEdit()">Salvar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!--//* Nova página  -->
		<v-dialog v-model="newPageModal.enabled" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Criar nova página</span>
				</v-card-title>
				<v-card-text>
					<v-layout wrap>
						<v-flex xs12>
							<v-text-field v-model="nomePagina" label="Nome da página" required></v-text-field>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" flat @click="newPageModal.enabled = false">Cancelar</v-btn>
					<v-btn color="green darken-1" dark @click="saveNewPage()">Salvar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!--//* Deletar página  -->
		<v-dialog v-model="deletePageModal.enabled" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Deseja deletar esta página?</span>
				</v-card-title>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" flat @click="deletePageModal.enabled = false">Cancelar</v-btn>
					<v-btn color="error" @click="saveRemove()">Deletar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- //*Toolbar e ícone de adicionar -->
		<v-toolbar card prominent>
			<v-toolbar-title class="body-2 grey--text">Administração de Páginas - {{sites.nome}}</v-toolbar-title>
			<v-spacer/>

			<v-tooltip bottom>
				<v-btn icon @click="newPage()" slot="activator">
					<v-icon>add</v-icon>
				</v-btn>
				<span>Nova Página</span>
			</v-tooltip>
		</v-toolbar>

		<!-- //*Data table -->
		<v-data-table light
			:headers="headers" :items="arrSites"
			rows-per-page-text="Colunas por página:"
			no-data-text="Não há nenhum site ativo."
			no-results-text="Sua busca não encontrou resultados."
		>
		<template slot="items" slot-scope="props">
			<td class="subheading pa-2 text-xs-left" :class="props.item.situation">{{ props.item.nome }} - <b>{{props.item.situation}}</b>
				<v-tooltip bottom>
					<v-icon small slot="activator" class="px-2" @click="edit(props.item)">edit</v-icon>
					<span>Mudar Nome</span>
				</v-tooltip>
					<span class="text-xs-right r-float-right">
						<v-tooltip bottom>
							<v-icon class="px-2" @click="$router.push({ name: 'editor', query: { paginaSelecionada: props.item.chave, siteSelecionado: $route.query.siteId}})" slot="activator">add</v-icon>
							<span>Adicionar/Editar Conteúdo</span>
						</v-tooltip>
						<v-tooltip bottom>
							<v-icon slot="activator" color="error" class="px-2" @click="remove(props.item)">delete</v-icon> 
							<span>Deletar</span>
						</v-tooltip>
					</span>
						<!-- //*Transferido link de aprovação para os sites. -->
						<!-- <v-tooltip bottom>
							<v-icon slot="activator" class="px-2" color="primary" @click="$router.push({ name: 'verPagina', query: {pageId: props.item['.key'], siteId: $route.query.siteId}})">share</v-icon>
							<span>Criar link de aprovação</span>
						</v-tooltip> -->
			</td>
		</template>
		<!-- Tradução -->
		<template slot="pageText" slot-scope="props">
			{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
		</template>
	</v-data-table>
	</div>
</template>

<script>
//*Importação do banco de dados do firebase
import { db } from '../firebase'

//*Constante de referencia ao banco de dados
const sitesRef = db.ref('sites')

export default {
    name: 'Paginas',

		firebase(){
			//*Constante usada para referenciar apenas o site
      const childRef = sitesRef.child(this.$route.query.siteId)
			return {
				sites: {
					source: childRef,
          asObject: true
				},
				//*Referencia do sites em forma de array
				arrSites: {
					source: childRef.child('/paginas/'),
				}
			}
		},

    data () {
        return {
					//*Banco de dados
					sites: {},
          siteId: null,

					//*Criação de página
          nomePagina: null,
          newPageModal: {
            enabled: false
          },
					//*Edição de página
          editPageModal: {
            enabled: false
          },
					//*Remoção de página
					deletePageModal: {
						enabled: false
					},
					//* Variáveis para a exibição da datalist
					headers: [
						{
							text: 'Páginas',
							align: 'center',
							sortable: false,
							value: 'name'
						},
					],
    	}
		},
		methods: {
			//* Nova página
      newPage() {
        this.newPageModal.enabled = true
      },
			saveNewPage() {
				var novoSite = sitesRef.child(this.$route.query.siteId + '/paginas/').push()
				novoSite.set({
					nome: this.nomePagina,
					content: '',
					situation: 'aguardando aprovação',
					chave: novoSite.key
				}).then(function(){
          // console.log('Deu bom')
          this.newPageModal.enabled = false
        }.bind(this))
			},
			//* Editar página
			edit(pagina) {
        this.editPageModal.enabled = true
        this.editPage = pagina
      },
      saveEdit() {
        sitesRef.child(this.$route.query.siteId + '/paginas/' + this.editPage.chave).update({
          nome: this.nomePagina
        }).then(function(){
          // console.log('Deu bom')
          this.editPageModal.enabled = false
        }.bind(this))
      },
			//* Remover página
			remove(pagina) {
				this.deletePageModal.enabled = true
        this.editPage = pagina
			},
			saveRemove() {
        sitesRef.child(this.$route.query.siteId + '/paginas/' + this.editPage.chave).remove().then(function(){
          // console.log('Deu bom')
          this.deletePageModal.enabled = false
        }.bind(this))
      }
		}		
}
</script>

<style lang="sass">
// *Style da Resultam
.r-float-right
	float: right

.r-situation
	text-transform: capitalize

.r-align
	margin: 0 auto

// *Alterações de Style do Vuetify
// 

</style>
